<template>
  <b-form-group
    label="Rol Bayrağı"
    label-for="role"
  >
    <validation-provider
      #default="{ errors }"
      name="Rol Bayrağı"
      rules="required"
    >
      <b-form-input
        id="role"
        v-model="dataItem.role"
        placeholder="Rol Bayrağı"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'RoleCard',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['userTypes/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>

<style scoped>

</style>
